import Footer from "../components//Footer";
import React from "react";
import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";
import AccountDetails from "./AccountDetails";
// import OrderDetails from "./OrderDetails";



const metadata = {
    title: `Account Details || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function AccountDetailsPage({ onPageReady }) {
    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <AccountDetails onLoaded={onPageReady}/>
            <Footer />
        </>
    );
}
